import GoogleMapReact from 'google-map-react';
import React, {useEffect, useRef, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import APICom from "../utils/helpers/APICom.js";
import '../assets/Styles/SimulationCSS/SliderSim.css';

const NearbyStopsFinderSimulation = () => {
  const [center, setCenter] = useState({ lat: 40.73061, lng: -73.935242 }); // Default to NYC
  const [zoom, setZoom] = useState(12); // Initial zoom level
  const [stops, setStops] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const xCancelSourceForGrid = useRef(null);
  const [stopCount, setStopCount] = useState(0);

  useEffect(() => {
    // Update stop count whenever stops data changes
    setStopCount(stops.length);
  }, [stops]); // Dependency on stops ensures the count updates whenever stops change

  // const handleSearch = async () => {
  //   const [lat, lng] = searchInput.split(",").map((coord) => parseFloat(coord.trim()));
  //   if (isNaN(lat) || isNaN(lng)) {
  //     alert("Please enter valid city name");
  //     return;
  //   }

  //   // Update the map center and zoom level
  //   setCenter({ lat, lng });
  //   setZoom(14); // Zoom into the area

  //   try {
  //     // Fetch stops from the API

  //     const params={
  //       latitude: lat,
  //       longitude: lng,
  //       radius:1*1609 //1609  # 1 mile = 1609 meters

  //     }

  //     setStops([]);
  //     setStopCount(0);

  //     let response = await APICom.fetchData("main", "street_intersections/get_Intersections", "post", {}, params, xCancelSourceForGrid.current)
  //     setStops(response.data.stops); // Assuming the API returns an array of stops
  //   } catch (error) {
  //     console.error("Error fetching stops:", error);
  //     alert("Failed to fetch stops.");
  //   }
  // };

  const handleSearch = async () => {
    if (!searchInput.trim()) {
      alert("Please enter a valid location name.");
      return;
    }

    try {
      // Fetch latitude and longitude from the Geocoding API
      const geocodingResponse = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(searchInput)}&format=json`);
      const geocodingData = await geocodingResponse.json();

      if (geocodingData.length === 0) {
        alert("Location not found. Please try a different name.");
        return;
      }

      const { lat, lon } = geocodingData[0];
      const latitude = parseFloat(lat);
      const longitude = parseFloat(lon);

      // Update the map center and zoom level
      setCenter({ lat: latitude, lng: longitude });
      setZoom(14);

      // Fetch stops from the API
      const params = {
        latitude,
        longitude,
        radius: 1 * 1609, // 1 mile = 1609 meters
      };

      setStops([]);
      setStopCount(0);

      const response = await APICom.fetchData("main","street_intersections/get_Intersections",  "post", {}, params, xCancelSourceForGrid.current);

      setStops(response.data.stops); // Assuming the API returns an array of stops

    } catch (error) {
      console.error("Error during geocoding or fetching stops:", error);
      alert("Failed to fetch data. Please try again.");
    }
  };

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {/* Search Bar */}
      <div
        style={{
          position: "absolute",
          top: 10,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 2,
        }}
      >
        <input
          type="text"
          placeholder="Enter Location..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          style={{ padding: "10px", width: "300px", marginRight: "10px" }}
        />
        <button onClick={handleSearch} style={{ padding: "10px 20px" }}>
          Search
        </button>
      </div>

      {/* Google Map */}
      <GoogleMapReact
       bootstrapURLKeys={{ key: 'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI', libraries: 'drawing'  }}
       yesIWantToUseGoogleMapApiInternals
        center={center}
        zoom={zoom}
      >
        {/* Render Stops as Markers */}
        {stops.map((stop, index) => (
            <div
                key={index}
                lat={stop.y} // Latitude
                lng={stop.x} // Longitude
                style={{
                width: "20px", // Marker size
                height: "20px", 
                backgroundColor: "red", // Marker color
                borderRadius: "50%", // Circular marker
                border: "2px solid white", // Optional white border for better visibility
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0px 0px 5px rgba(0,0,0,0.5)", // Add shadow for better visibility
                transform: "translate(-50%, -50%)", // Center marker over lat/lng
                }}
            >
                <span style={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>🚏</span>
            </div>
            ))}

            {/* User Location Marker */}
                <div
                lat={center.lat} // User-entered latitude
                lng={center.lng} // User-entered longitude
                style={{
                    width: "25px", // Slightly larger than stop markers
                    height: "25px",
                    backgroundColor: "blue", // Different color to distinguish user location
                    borderRadius: "50%", // Circular marker
                    border: "3px solid white", // White border for visibility
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 0px 8px rgba(0,0,0,0.6)", // Shadow for emphasis
                    transform: "translate(-50%, -50%)", // Center marker
                }}
                >
                <span style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>📍</span>
                </div>


             

      </GoogleMapReact>
      {/* Stop count label */}
      <div
                    style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#b49587",
                    padding: "10px 20px",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    }}
                >
                    Total Intersection Count Within One Mile: {stopCount}
                </div>
    </div>
  );
};

export default NearbyStopsFinderSimulation;
